import { cn } from "@/lib/utils";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  narrow?: boolean;
  wide?: boolean;
  as?: React.ElementType;
}

export function Container({
  children,
  className,
  narrow,
  wide,
  as: Component = "div",
}: ContainerProps) {
  return (
    <Component
      className={cn(
        "mx-auto w-full px-4 sm:px-6 lg:px-8",
        narrow && "max-w-3xl",
        wide && "max-w-7xl",
        !narrow && !wide && "max-w-[1280px]",
        className,
      )}
    >
      {children}
    </Component>
  );
}
